import "bootstrap/dist/css/bootstrap.min.css";
import { FileText } from "lucide-react";
import { useCallback, useState } from "react";
import BotaoRelatorio from "../components/BotaoRelatorio";

const CentralRelatorios = () => {
  const [filtroCategoria] = useState("todos");

  // ✅ ESTADOS PARA O MODAL DE LOADING DOS RELATÓRIOS
  const [relatorioLoading, setRelatorioLoading] = useState(false);
  const [relatorioTipo, setRelatorioTipo] = useState("");
  const [relatorioNome, setRelatorioNome] = useState("");
  const [relatorioProgresso, setRelatorioProgresso] = useState(0);
  const [relatorioMensagem, setRelatorioMensagem] = useState("");
  const [relatorioResultado, setRelatorioResultado] = useState(null);
  const [relatorioInterval, setRelatorioInterval] = useState(null);

  // ✅ FUNÇÃO PARA INICIAR GERAÇÃO DO RELATÓRIO
  const iniciarGeracaoRelatorio = useCallback(
    (tipo, nome) => {
      // ✅ MENSAGENS MOTIVACIONAIS PARA O LOADING
      const mensagensMotivacionais = [
        "📊 Compilando dados financeiros...",
        "🔍 Analisando movimentações orçamentárias...",
        "📈 Processando informações gerenciais...",
        "💰 Consolidando valores por centro de custo...",
        "📋 Formatando relatório para visualização...",
        "🎯 Preparando insights para tomada de decisão...",
        "⚡ Otimizando dados para melhor performance...",
        "🔄 Sincronizando informações mais recentes...",
      ];

      setRelatorioLoading(true);
      setRelatorioTipo(tipo);
      setRelatorioNome(nome);
      setRelatorioProgresso(0);
      setRelatorioMensagem(mensagensMotivacionais[0]);
      setRelatorioResultado(null);

      // Simular progresso
      let progresso = 0;
      let mensagemIndex = 0;

      const intervalo = setInterval(() => {
        progresso += Math.random() * 15 + 5;
        mensagemIndex = Math.floor(
          (progresso / 100) * mensagensMotivacionais.length
        );

        if (progresso >= 95) {
          progresso = 95;
          clearInterval(intervalo);
        }

        setRelatorioProgresso(Math.min(progresso, 95));
        setRelatorioMensagem(
          mensagensMotivacionais[
            Math.min(mensagemIndex, mensagensMotivacionais.length - 1)
          ]
        );
      }, 800);

      setRelatorioInterval(intervalo);
    },
    []
  );

  // ✅ FUNÇÃO PARA FINALIZAR GERAÇÃO DO RELATÓRIO
  const finalizarGeracaoRelatorio = useCallback(
    (sucesso, mensagem) => {
      if (relatorioInterval) {
        clearInterval(relatorioInterval);
        setRelatorioInterval(null);
      }

      setRelatorioProgresso(100);
      setRelatorioMensagem(
        sucesso ? "✅ Relatório gerado com sucesso!" : "❌ Erro na geração"
      );
      setRelatorioResultado({ sucesso, mensagem });

      setTimeout(() => {
        if (sucesso) {
          fecharModalRelatorio();
        }
      }, 2000);
    },
    [relatorioInterval]
  );

  // ✅ FUNÇÃO PARA FECHAR MODAL DE RELATÓRIO
  const fecharModalRelatorio = useCallback(() => {
    if (relatorioInterval) {
      clearInterval(relatorioInterval);
      setRelatorioInterval(null);
    }

    setRelatorioLoading(false);
    setRelatorioTipo("");
    setRelatorioNome("");
    setRelatorioProgresso(0);
    setRelatorioMensagem("");
    setRelatorioResultado(null);
  }, [relatorioInterval]);

  // Parâmetros para os relatórios
  const PpCODCOLIGADA = localStorage.getItem("PCODCOLIGADA");
  const PpCODFILIAL = localStorage.getItem("PCODFILIAL");
  const PpANO = localStorage.getItem("selectedYear");
  const PpCODUSUARIO = localStorage.getItem("username");

  const agora = new Date();
  agora.setDate(agora.getDate() + 1);
  const ultimaAtualizacao = agora.toISOString().split("T")[0];

  // Lista de relatórios disponíveis
// Lista de relatórios disponíveis
const relatorios = [
  {
    id: 1,
    nome: "Relatório Consolidado",
    descricao: "Resumo Orcamento - Sintetico",
    categoria: "Orçamentário",
    icone: "📊",
    ultimaAtualizacao,
  },
  {
    id: 2,
    nome: "Relatório Detalhado",
    descricao: "Orcamento por CC e Natureza",
    categoria: "Orçamentário",
    icone: "📊",
    ultimaAtualizacao,
  },
];


  const relatoriosFiltrados =
    filtroCategoria === "todos"
      ? relatorios
      : relatorios.filter((r) => r.categoria === filtroCategoria);

  return (
    // Mesmo invólucro das telas de lançamento (ver Lacamentos.jsx): largura
    // cheia com px-4 e um cartão branco translúcido, em vez do container
    // centrado com fundo cinza que esta tela usava.
    <div className="container-fluid py-2 px-4" style={{ minHeight: "100vh" }}>
      <div
        className="bg-white rounded shadow p-4"
        style={{ backgroundColor: "#ffffffb3" }}
      >
        {/* TÍTULO — ano e filial na própria linha, como nas demais telas.
            Substitui a faixa "Informações Atuais", que repetia essa mesma
            informação num bloco separado. O usuário logado saiu daqui: a
            sidebar já mostra o nome. */}
        <h5
          className="text-dark fw-semibold mb-1"
          style={{ fontSize: "1.50rem" }}
        >
          <FileText
            size={28}
            className="me-2"
            style={{ color: "#0d6efd", verticalAlign: "text-bottom" }}
          />
          Central de <b className="text-primary">Relatórios</b> —{" "}
          <span className="text-dark fw-semibold">
            ✅ Ano{" "}
            {localStorage.getItem("selectedYear") || new Date().getFullYear()} -{" "}
            {localStorage.getItem("NomeFilial") || "N/A"}
          </span>
        </h5>

        <p className="text-muted small mb-3">
          Selecione o relatório desejado e escolha o formato para download
        </p>

        {/* ✅ INFORMAÇÕES ATUAIS — a pedido do usuário, mantida mesmo com ano e
            filial já aparecendo no título. É indicador de contexto, não filtro:
            os relatórios sempre saem com a filial e o ano em vigor. */}
        <div className="alert alert-info d-flex align-items-center">
          <div className="me-3" style={{ fontSize: "1.5rem" }}>
            ℹ️
          </div>
          <div>
            <strong>Informações Atuais:</strong>
            <div className="mt-1">
              <span className="badge bg-primary me-2">
                🏢 {localStorage.getItem("NomeFilial") || "N/A"}
              </span>
              <span className="badge bg-primary me-2">
                📅 Ano:{" "}
                {localStorage.getItem("selectedYear") ||
                  new Date().getFullYear()}
              </span>
              <span className="badge bg-primary me-2">
                👤 {localStorage.getItem("username") || "N/A"}
              </span>
            </div>
          </div>
        </div>

        {/* Cards compactos em duas colunas. O card antigo era alto demais para
            o que carregava — ícone de 2,5rem, badge de categoria e dois botões
            chapados empilhados — e em col-lg-4 deixava um terço da tela vazio
            com apenas dois relatórios. */}
        <div className="row g-3">
          {relatoriosFiltrados.length === 0 && (
            <div className="col-12">
              <div className="alert alert-info mb-0 text-center">
                Nenhum relatório encontrado.
              </div>
            </div>
          )}

          {relatoriosFiltrados.map((relatorio) => (
            <div key={relatorio.id} className="col-md-6">
              <div className="p-3 bg-white rounded-3 shadow-sm border h-100">
                <div className="d-flex align-items-center mb-1">
                  <span className="me-2" style={{ fontSize: "1.25rem" }}>
                    {relatorio.icone}
                  </span>
                  <h6 className="mb-0 fw-bold">{relatorio.nome}</h6>
                </div>

                <p className="text-muted small mb-1">{relatorio.descricao}</p>

                <p className="text-muted mb-3" style={{ fontSize: "0.75rem" }}>
                  {relatorio.categoria} · atualizado em{" "}
                  {new Date(relatorio.ultimaAtualizacao).toLocaleDateString(
                    "pt-BR"
                  )}
                </p>

                <div className="d-flex gap-2">
                  <BotaoRelatorio
                    tipo={relatorio.descricao}
                    texto="PDF"
                    icone="📄"
                    formato="pdf"
                    parametros={{
                      pCODCOLIGADA: PpCODCOLIGADA,
                      pCODFILIAL: PpCODFILIAL,
                      pANO: PpANO,
                      pCODUSUARIO: PpCODUSUARIO,
                    }}
                    abrirEmModal={false}
                    onStartGeneration={(tipo, texto) =>
                      iniciarGeracaoRelatorio(
                        tipo,
                        `${relatorio.nome} - ${texto}`
                      )
                    }
                    onFinishGeneration={finalizarGeracaoRelatorio}
                    className="btn btn-sm btn-outline-danger flex-fill"
                  />

                  <BotaoRelatorio
                    tipo={relatorio.descricao}
                    texto="Excel"
                    icone="📊"
                    formato="excel"
                    parametros={{
                      pCODCOLIGADA: PpCODCOLIGADA,
                      pCODFILIAL: PpCODFILIAL,
                      pANO: PpANO,
                      pCODUSUARIO: PpCODUSUARIO,
                    }}
                    abrirEmModal={false}
                    onStartGeneration={(tipo, texto) =>
                      iniciarGeracaoRelatorio(
                        tipo,
                        `${relatorio.nome} - ${texto}`
                      )
                    }
                    onFinishGeneration={finalizarGeracaoRelatorio}
                    className="btn btn-sm btn-outline-success flex-fill"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ✅ MODAL DE LOADING PARA RELATÓRIOS */}
      {relatorioLoading && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.8)", zIndex: 9999 }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header bg-primary text-white border-0">
                <h5 className="modal-title d-flex align-items-center">
                  <div
                    className="spinner-grow spinner-grow-sm me-2"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  📊 Gerando Relatório {relatorioNome}
                </h5>
                {relatorioResultado && !relatorioResultado.sucesso && (
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={fecharModalRelatorio}
                  ></button>
                )}
              </div>

              <div className="modal-body text-center py-4">
                {/* Animação de Loading */}
                <div className="mb-4">
                  <div className="position-relative d-inline-block">
                    <div
                      className="spinner-border text-primary"
                      role="status"
                      style={{ width: "4rem", height: "4rem" }}
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <div
                      className="position-absolute top-50 start-50 translate-middle"
                      style={{ fontSize: "1.5rem" }}
                    >
                      📊
                    </div>
                  </div>
                </div>

                {/* Barra de Progresso */}
                <div className="mb-3">
                  <div className="progress" style={{ height: "8px" }}>
                    <div
                      className={`progress-bar progress-bar-striped progress-bar-animated ${
                        relatorioProgresso === 100
                          ? relatorioResultado?.sucesso
                            ? "bg-success"
                            : "bg-danger"
                          : "bg-primary"
                      }`}
                      role="progressbar"
                      style={{ width: `${relatorioProgresso}%` }}
                      aria-valuenow={relatorioProgresso}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                  <small className="text-muted">
                    {relatorioProgresso.toFixed(0)}% concluído
                  </small>
                </div>

                {/* Mensagem Status */}
                <div className="mb-3">
                  <p className="mb-1 fw-medium text-primary">
                    {relatorioMensagem}
                  </p>
                  {relatorioResultado && (
                    <div
                      className={`alert ${
                        relatorioResultado.sucesso
                          ? "alert-success"
                          : "alert-danger"
                      } mt-3`}
                    >
                      {relatorioResultado.mensagem}
                    </div>
                  )}
                </div>

                {/* Dicas Motivacionais */}
                {!relatorioResultado && (
                  <div className="mt-4 p-3 bg-light rounded">
                    <h6 className="text-muted mb-2">
                      💡 Enquanto você aguarda...
                    </h6>
                    <small className="text-muted">
                      {relatorioTipo === "lancamentos-analitico"
                        ? "O relatório analítico fornece informações detalhadas para análise profunda dos dados orçamentários."
                        : "O relatório sintético oferece uma visão consolidada e resumida dos principais indicadores."}
                    </small>
                  </div>
                )}

                {/* Informações Técnicas */}
                <div className="mt-3">
                  <small className="text-muted d-block">
                    🏢 Filial: {localStorage.getItem("NomeFilial") || "N/A"}
                  </small>
                  <small className="text-muted d-block">
                    📅 Período:{" "}
                    {localStorage.getItem("selectedYear") ||
                      new Date().getFullYear()}
                  </small>
                  <small className="text-muted d-block">
                    👤 Usuário: {localStorage.getItem("username") || "N/A"}
                  </small>
                </div>
              </div>

              {/* Footer apenas para erros */}
              {relatorioResultado && !relatorioResultado.sucesso && (
                <div className="modal-footer border-0">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={fecharModalRelatorio}
                  >
                    Fechar
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      fecharModalRelatorio();
                      setTimeout(() => {
                        if (relatorioTipo === "lancamentos-analitico") {
                          iniciarGeracaoRelatorio(
                            "lancamentos-analitico",
                            "Analítico"
                          );
                        } else {
                          iniciarGeracaoRelatorio(
                            "lancamentos-sintetico",
                            "Sintético"
                          );
                        }
                      }, 100);
                    }}
                  >
                    🔄 Tentar Novamente
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <style>{`
        .hover-shadow:hover {
          transform: translateY(-5px);
          box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.15) !important;
        }
        
        .modal.d-block {
          display: block !important;
        }
      `}</style>
    </div>
  );
};

export default CentralRelatorios;
